<template>

<app-section>

    <app-panel title="Users" :is-loading="is.loading" :is-empty="is.empty">

        <app-table>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th width="60"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in collection" :key="item.id">
                    <td>{{ item.firstname }} {{ item.lastname }}</td>
                    <td>{{ item.email }}</td>
                    <td><app-button text="View" route="Organisation.User" :params="{id: item.id, organisation: $route.params.id}" /></td>
                </tr>   
            </tbody>
        </app-table>

    </app-panel>

    <app-actions>

        <app-button text="Add User" route="Organisation.User" :params="{id: 'create', organisation: $route.params.id}" />

    </app-actions>

</app-section>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

    mixins: [mixCollection],

    data: function() {
    
        return {
            api: ['organisation', this.$route.params.id ,'users']
        }
    
    }

}

</script>

<style scoped>

</style>
